import {
  Finding,
  Severity,
  SEVERITY_ORDER,
  SEVERITY_COLORS,
} from './types';

export function countBySeverity(
  findings: Finding[],
): Record<Severity, number> {
  const counts = Object.fromEntries(
    SEVERITY_ORDER.map(s => [s, 0]),
  ) as Record<Severity, number>;
  for (const f of findings) {
    if (f.active && counts[f.severity] !== undefined) {
      counts[f.severity]++;
    }
  }
  return counts;
}

export function calculateResolvedPercentage(findings: Finding[]): number {
  if (findings.length === 0) return 0;
  const resolved = findings.filter(f => !f.active).length;
  return Math.round((resolved / findings.length) * 100);
}

export function getMostRecentFindingDate(
  findings: Finding[],
): string | null {
  if (findings.length === 0) return null;
  return findings.reduce(
    (latest, f) => (f.date > latest ? f.date : latest),
    findings[0].date,
  );
}

export function groupByMonth(
  findings: Finding[],
  months: number = 6,
): { month: string; count: number }[] {
  const now = new Date();
  const result: { month: string; count: number }[] = [];
  for (let i = months - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const count = findings.filter(f => f.date.startsWith(key)).length;
    result.push({ month: key, count });
  }
  return result;
}

export function getSeverityColor(severity: Severity): string {
  return SEVERITY_COLORS[severity] ?? '#9e9e9e';
}
